// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { setCurrentCategoryId } from '../../redux/actionsCreators';
import { dashedToNormalString, getCategory } from '../../utils/methods.js';
import { CategoryListWrapper } from '../../containers';
import { servicesCategories } from '../../utils/variables';

import { preloader } from '../../utils/animation';

import HorizontalScroll from '../HorizontalScroll';
import Loader from '../Loader';
import Category from './index';
import CategoryNav from './Nav';

import type { CategoryType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';
import styles from './styles.scss';

type Props = {
  match: Object,
  categories: Array<CategoryType>,
  currentCategoryId: ?number,
  setCurrentCategoryId: (id: ?number) => void,
};

class CategoryList extends React.Component<Props> {
  componentDidMount = () => {
    preloader().play();

    // $FlowFixMe
    document.body.classList.add('rentals-category-page');
  };

  getList = (): Array<CategoryType> => {
    const { match, categories } = this.props;

    if (categories && match && match.params.subcategory) {
      const matchingCategory = getCategory(categories, dashedToNormalString(match.params.subcategory));

      if (!matchingCategory) return [];

      return matchingCategory.children.length > 0 ? matchingCategory.children : [];
    }

    return [];
  };

  componentWillUnmount = () => {
    // $FlowFixMe
    document.body.classList.remove('rentals-category-page');

    this.props.setCurrentCategoryId();
  };

  render(): React.Node {
    const list: Array<CategoryType> = this.getList();
    const { match, categories } = this.props;

    const rentalCategories: Array<CategoryType> = categories.filter(
      category => category.children.length > 0 && !servicesCategories.includes(category.name),
    );

    return (
      <React.Fragment>
        <div className="category-rentals">
          <CategoryListWrapper>
            {list.length > 3 ? (
              <div className="flex-wrap">
                <h1 className="category-rentals_title">{match.params.subcategory}</h1>
              </div>
            ) : (
              <h1 className="category-rentals_title">{match.params.subcategory}</h1>
            )}
            {list.length > 0 ? (
              <HorizontalScroll>
                {list.map(category => (
                  <Category
                    key={category.name}
                    category={category}
                    type={match.params.subcategory ? 'subcategory' : 'default'}
                    onMouseEnter={() => this.props.setCurrentCategoryId(category.id)}
                  />
                ))}
              </HorizontalScroll>
            ) : (
              <Loader />
            )}
          </CategoryListWrapper>
          <div className="aside">
            <CategoryNav categories={rentalCategories} activeCategoryName={match.params.subcategory} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: DefaultStateType): { categories: Array<CategoryType>, currentCategoryId: ?number } => ({
  categories: state.categories,
  currentCategoryId: state.currentCategoryId,
});

const mapDispatchToProps = dispatch => ({
  setCurrentCategoryId(id: number) {
    dispatch(setCurrentCategoryId(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CategoryList);



// WEBPACK FOOTER //
// ./src/components/Category/List.js